import { QueryClient } from '@tanstack/react-query';

/** App-wide singleton so non-React code (logout, 401 redirect) can clear cached server state. */
export const queryClient = new QueryClient();
